// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3aqv3","tab":"Tabs_tab__20WAJ","selected":"Tabs_selected__132PH"};